module.exports = __webpack_public_path__ + "static/media/attende_tab_close.788aa1cb.svg";